import { render, staticRenderFns } from "./DashAsideRight.vue?vue&type=template&id=22dc498d&scoped=true&"
import script from "./DashAsideRight.vue?vue&type=script&lang=ts&"
export * from "./DashAsideRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dc498d",
  null
  
)

export default component.exports